var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',{staticClass:"font-weight-bold black--text"},[_vm._v(_vm._s(_vm.labTitle))]),_c('v-card-text',{staticClass:"text-subtitle-1 black--text"},[_vm._v(" "+_vm._s(_vm.labPreview)+" "),_c('router-link',{attrs:{"to":"lab/about"}},[_vm._v("Читать полностью...")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }